import { createSvgIcon } from '@automata/mui-theme';
export const DispenseIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M36.2635 61.7703L22.1213 47.6281L20 49.7495L34.1421 63.8916L36.2635 61.7703Z" />
    <path d="M34.1546 63.8914L48.2967 49.7492L46.1754 47.6279L32.0332 61.7701L34.1546 63.8914Z" />
    <path d="M32.6484 60.1084H35.6484V32.1084H32.6484V60.1084Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.969 54.1975C61.7132 55.2015 60.2868 55.2015 60.031 54.1975L52 22.6835H70L61.969 54.1975ZM61 45.8516L66.1396 25.6835L55.8604 25.6835L61 45.8516Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55 13H67V22.6105H55V13ZM52 10H70V22.6835H52V10Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61 79C63.4801 79 66 76.6717 66 73.1385C66 72.1516 65.6721 70.8544 65.0016 69.322C64.3456 67.8227 63.4456 66.2864 62.5043 64.8752C61.9915 64.1065 61.4771 63.3906 61 62.756C60.5229 63.3906 60.0085 64.1065 59.4957 64.8752C58.5544 66.2864 57.6544 67.8227 56.9984 69.322C56.3279 70.8544 56 72.1516 56 73.1385C56 76.6717 58.5199 79 61 79ZM59.0662 60.3451C56.6987 63.4018 53 68.8615 53 73.1385C53 78.0326 56.5817 82 61 82C65.4183 82 69 78.0326 69 73.1385C69 68.8615 65.3013 63.4018 62.9338 60.3451C61.8195 58.9064 61 58 61 58C61 58 60.1806 58.9064 59.0662 60.3451Z"
    />
    <path d="M58 37H64L60.75 48L58 37Z" />
  </svg>,
  'DispenseIcon'
);
